export const determineValueChange = (values: number[]) =>
  values.length > 1 && values[values.length - 1]
    ? (values[0] - values[values.length - 1]) / values[values.length - 1]
    : 0
